import { Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { visibility as visibilities } from "../../../../../@types/listings/unions";
import { CheckedMenuItemLabel } from "components/__haim/Common/CheckedMenuItemLabel";
import type { ChangeEvent } from "react";
import type { Visibility } from "../../../../../@types/listings/unions";

type ListingDialogInputVisibilityProps = {
  loading: boolean;
  visibility: Visibility;
  organizationId: null | string;
  handleChange: ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => void;
};

export function ListingDialogInputVisibility({
  loading,
  visibility,
  organizationId,
  handleChange
}: ListingDialogInputVisibilityProps): JSX.Element {
  const { t: translate } = useTranslation();

  const handleGetLabel = (labelValue: string): string => {
    return translate(`listingsPage.visibilityLabel.${labelValue}`);
  };

  return (
    <FormControl sx={{ minWidth: 140 }} disabled={loading} fullWidth>
      <InputLabel>{translate("listingsPage.tableColumns.visibility")}</InputLabel>
      <Select
        name="visibility"
        label={translate("listingsPage.tableColumns.visibility")}
        value={visibility}
        onChange={handleChange}
        renderValue={handleGetLabel}
      >
        {visibilities.map((option) => (
          <MenuItem
            value={option}
            disabled={option === "organization" && !organizationId}
            key={option}
          >
            <CheckedMenuItemLabel selected={option === visibility}>
              {handleGetLabel(option)}
            </CheckedMenuItemLabel>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
